import axios from "axios";
import { getApiBaseUrl } from "../../config";

const apiPrefixReports = getApiBaseUrl("reports");

export const getOverAllSatisfactionChartData = async (req_body, authtoken) => {
  return await axios.post(
    `${apiPrefixReports}/api/v1/svc-smart-tag/charts-experience-average`,
    req_body,
    {
      headers: {
        token: authtoken,
      },
    },
  );
};

export const getBrandPreferenceChartData = async (req_body, authtoken) => {
  return await axios.post(
    `${apiPrefixReports}/api/v1/svc-smart-tag/charts-experience-brand`,
    req_body,
    {
      headers: {
        token: authtoken,
      },
    },
  );
};
